import { OPERATIONS_DISPLAY, SEGMENT_COMPARATOR } from "@/consts/segment";
import { i18n } from "@/boot/i18n";

export default class MetadataParse {
  createGroupFilters(filtersFlatted) {
    return filtersFlatted
      .reduce((accumulator, current) => {
        if (accumulator.length === 0) {
          accumulator.push([current]);
        } else {
          accumulator[accumulator.length - 1].push(current);
        }
        if (current.comparator === SEGMENT_COMPARATOR.OR) {
          accumulator.push([]);
        }
        return accumulator;
      }, [])
      .filter((current) => current.length);
  }

  async getSelectedFromMetadata(metadata) {
    if (!metadata) return [];

    const metadataParse = await JSON.parse(metadata);
    if (metadataParse?.length) {
      let filters = [];
      let comparatorOr = false;

      metadataParse.forEach((m) => {
        m.forEach((metadataFilter, index) => {
          if (m.length - 1 === index) {
            comparatorOr = true;
          }
          const filter = this.getFilterFromMetadata(metadataFilter, comparatorOr);
          filters.push(filter);
          comparatorOr = false;
        });
      });

      if (filters.length) {
        filters[filters.length - 1].comparator = SEGMENT_COMPARATOR.AND;
      }

      return filters;
    } else {
      return [];
    }
  }

  getFilterFromMetadata(metadata, comparatorOr = false) {
    /**
     * Metadata v1
     *
     * 0: Operation (Tipo de operação)
     * 1: Field (Campo que sera filtrado)
     * 2: Values (Array de valores para o filtro)
     * 3: Kind (Define se é Interaction (1) ou customer (2))
     * 4: Não é utilizado no back, somente no front
     * 5: DataType (Define se vai ser um tipo de filtro dynamic (0) ou static (1))
     * 6: Name
     */

    return {
      key: Math.floor(Math.random() * 999) + 100,
      field: { id: metadata[6], kind: metadata[3], type: metadata[4], dataType: metadata[5], value: metadata[1] },
      operation: { display: i18n.t(OPERATIONS_DISPLAY[metadata[0]]), value: metadata[0] },
      value: metadata[2][0],
      comparator: comparatorOr ? SEGMENT_COMPARATOR.OR : SEGMENT_COMPARATOR.AND
    };
  }

  getMetadataFromFilter(filterGroups) {
    if (!filterGroups.length) return null;

    const filterGroupsRemap = filterGroups.map((group) => {
      return group.map((filter) => {
        /**
         * 0: Operation (Tipo de operação)
         * 1: Field (Campo que sera filtrado)
         * 2: Values (Array de valores para o filtro)
         * 3: Kind (Define se é Interaction (1) ou customer (2))
         * 4: Não é utilizado no back, somente no front
         * 5: DataType (Define se vai ser um tipo de filtro dynamic (0) ou static (1))
         * 6: Name
         */

        return [
          filter.operation.value,
          filter.field.value, // Pergunta e Resposta
          [filter.value], // VALUE
          filter.field.kind,
          filter.field.type,
          filter.field.dataType,
          filter.field.id // UUID
        ];
      });
    });

    return JSON.stringify(filterGroupsRemap);
  }
}
